module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YUkbyt/tc-custom/9781623808839.jpg?1718106505938",
      "alt": "This image is the cover for the book Sobre luces y sombras, Caballo Oscuro"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sobre luces y sombras, Caballo Oscuro\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("La secuela de Fuera de la oscuridad"), _c('br'), _vm._v("Volumen 3 de la serie Caballo Oscuro")])])]), _c('p', [_vm._v("Jeff, Evan y Dan han estado juntos los dos últimos años, felices. Todavía tienen problemas, especialmente entre Evan y Dan, pero la mayoría de las veces logran convertir esos desacuerdos interpersonales en tensión sexual, que luego resuelven, así que nadie se queja.")]), _vm._v(" "), _c('p', [_vm._v("Dan llevaba muchos años sin ver a su hermana y cuando esta aparece, embarazada de siete meses y prófuga de la justicia, y la situación se transforma de complicada a abrumadora. Jeff y Evan quieren ayudar, pero como Evan teme por la seguridad de su propia hermana y Jeff debe luchar para mantener bajo control sus problemas de salud, están un poco distraídos.")]), _vm._v(" "), _c('p', [_vm._v("Mientras la hermana de Dan lucha con su pasado, Evan parece querer apostar por su futuro. Con las emociones y los lazos familiares empujándolos en diferentes direcciones, los tres deberán mantenerse juntos, o la gente que aman puede lograr separarlos.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate Sherwood, Georgette Asi\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0